import sanitizeHtml from 'sanitize-html'

const GLOBAL_ATTRS = ['style', 'class']

/** Merge global attributes (style, class) into each tag-specific entry so they aren't overridden by the wildcard. */
function mergeGlobalAttrs(
  defaults: Record<string, sanitizeHtml.AllowedAttribute[]>,
): Record<string, sanitizeHtml.AllowedAttribute[]> {
  const merged: Record<string, sanitizeHtml.AllowedAttribute[]> = {}
  for (const [tag, attrs] of Object.entries(defaults)) {
    merged[tag] = [...attrs, ...GLOBAL_ATTRS]
  }
  return merged
}

export default function sanitizeHtmlContent(html: string) {
  return sanitizeHtml(html, {
    allowedTags: [...sanitizeHtml.defaults.allowedTags, 'img'],
    allowedAttributes: {
      ...mergeGlobalAttrs(sanitizeHtml.defaults.allowedAttributes),
      img: ['src', 'alt', 'width', 'height', 'loading', ...GLOBAL_ATTRS],
      '*': GLOBAL_ATTRS,
    },
  })
}
